import React from 'react';
import PropTypes from 'prop-types';
import Icon from '~/components/Icon';
import * as S from './styles';

export default function CustomArrow({
  className,
  style,
  onClick,
  orientation,
  isVisible,
}) {
  return (
    <S.ArrowContainer
      className={className}
      style={{ ...style, display: 'flex' }}
      onClick={onClick}
      isVisible={isVisible}
    >
      <Icon
        name={`chevron${orientation === 'left' ? `Left` : `Right`}`}
        size={15}
        color="white"
      />
    </S.ArrowContainer>
  );
}

CustomArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  orientation: PropTypes.string,
  isVisible: PropTypes.bool,
};

CustomArrow.defaultProps = {
  className: '',
  style: {},
  onClick: () => {},
  orientation: 'left',
  isVisible: true,
};
